import React, { Component } from 'react'
import Formsy from 'formsy-react'
import Select from 'components/UI/FormInput/SettingsSelect'
import IconButton from 'components/UI/Button/IconButton'

import { Wrapper, TitleRow, StyledIconButton } from './YourDetailsColumn.styles'
import { phoneMaxWidth, Title, StyledFormInput, InputExplanationText } from '../../../../DashboardSettings.styles'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'

export default class YourDetailsColumn extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isEditMode: false
    }

    this.onInputChange = this.onInputChange.bind(this)
  }

  onInputChange (e) {
    if (e.target.name === 'safeMarket') {
      return this.props.setTeacherState({
        field: e.target.name,
        value: e.target.value === 'On'
      })
    }

    this.props.setTeacherState({
      field: e.target.name,
      value: e.target.value
    })
  }

  renderTitleAndButtons () {
    const { screenWidth, isEditMode } = this.props

    return (
      <TitleRow>
        <Title>
					Your Details
        </Title>
        {screenWidth <= phoneMaxWidth &&
					(isEditMode
					  ? <StyledIconButton
					    data-save
					    element='button'
					    type='submit'
					    form='your-account'
					    bgColor={colors.grassGreen}
					    color='white'
					    iconName='check'
					    size='small'
					    onClick={() => this.props.setEditMode(false)}
					  >
							Save
					  </StyledIconButton>
					  : <StyledIconButton
					    bgColor={colors.orange}
					    iconName='pencil'
					    color='white'
					    size='small'
					    columnView
					    onClick={() => this.props.setEditMode(true)}
					  >
							Edit
					  </StyledIconButton>
					)}
      </TitleRow>
    )
  }

  render () {
    const { teacherDetails, isEditMode, loading } = this.props
    if (loading) return null

    const commonProps = {
      placeholderColor: isEditMode ? colors.grey : colors.orange,
      backgroundColor: isEditMode ? null : colors.paleBlue,
      inputColor: isEditMode ? null : colors.darkPurple,
      fieldNameColor: colors.pink,
      width: '220px',
      noBorder: !isEditMode,
      focusColor: colors.orange,
      backgroundFocusColor: colors.lightOrange,
      element: 'button',
      disabled: !isEditMode,
      autoComplete: 'off',
      narrow: true,
      textSize: '15px',
      fieldNameSize: '18px'
    }

    return (
      <Wrapper>
        {this.renderTitleAndButtons()}
        <StyledFormInput
          {...commonProps}
          value={teacherDetails.name}
          onChange={this.onInputChange}
          name='name'
          fieldName='Your name'
          placeholder='Your name'
          required
        />
        {/* autofill fix */}
        <input
          value='autofill'
          onChange={() => {}}
          name='email'
          placeholder='Email'
          hidden
        />
        {/* autofill fix */}
        <StyledFormInput
          {...commonProps}
          value={teacherDetails.email}
          onChange={this.onInputChange}
          name='email'
          fieldName='Email'
          placeholder='Email'
          required
          validations='isEmail'
          validationError='Email not valid'
        />
        <StyledFormInput
          {...commonProps}
          value={teacherDetails.password}
          onChange={this.onInputChange}
          name='password'
          fieldName='Password'
          placeholder='••••••••••'
          placeholderColor={isEditMode ? colors.grey : colors.darkPurple}
          type='password'
          validations='minLength:4'
          validationError='Password too short'
        />
        <StyledFormInput
          {...commonProps}
          value={teacherDetails.twitter}
          onChange={this.onInputChange}
          name='twitter'
          fieldName='Twitter'
          placeholder='Twitter'
        />
        <StyledFormInput
          {...commonProps}
          value={teacherDetails.skype}
          onChange={this.onInputChange}
          name='skype'
          fieldName='Skype'
          placeholder='Skype'
        />
      </Wrapper>
    )
  }
}
